import { Attribute, Shift } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import { Image } from 'expo-image'
import { t } from 'app/i18l'
import React from 'react'
import { View } from 'react-native'
import { UserAvatar } from '../user/user_avatar'

interface UserPositionAndAttributeProps {
  shift: Shift
}
export function UserPositionAndAttribute({
  shift,
}: UserPositionAndAttributeProps) {
  const styles = useStyles()
  return (
    <View style={styles.container}>
      {shift.user?.photoUrl ? (
        <UserAvatar user={shift.user} size="medium" />
      ) : (
        <Image
          source={require('assets/open_shifts/search.png')}
          style={styles.searchIcon}
        />
      )}
      <View style={styles.userContainer}>
        {shift.user?.firstName && shift.user?.firstName && (
          <Text
            style={styles.name}
          >{`${shift.user?.firstName} ${shift.user?.lastName}`}</Text>
        )}

        <Text style={styles.positionText}>
          {shift.position ?? t('anyPosition')}
        </Text>
      </View>
      {/* <Attributes attributes={shift?.attributes} /> */}
    </View>
  )
}

interface AttributesProps {
  attributes?: Attribute[]
}
function Attributes(props: AttributesProps) {
  const styles = useStyles()

  if (!props.attributes || props.attributes.length === 0) {
    return null
  }

  const attribute = props.attributes[0]

  if (attribute.name.length === 0) {
    return null
  }

  return (
    <Text style={styles.attribute}>
      {attribute.icon}
      <Text style={styles.attributeText}> {attribute.name}</Text>
    </Text>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 10,
  },
  searchIcon: {
    height: 45,
    width: 45,
    margin: 10,
  },
  name: {
    fontFamily: font.bold,
    fontSize: 19,
  },
  positionText: {
    fontSize: 16,
    color: theme.colors?.grey2,
  },
  attribute: {
    paddingLeft: 10,
    fontSize: 18,
  },
  attributeText: {
    color: theme.colors?.grey1,
  },
  userContainer: {
    marginHorizontal: 10,
  },
}))
